// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GtLke","buttons":"styles_buttons__18yGB"};